import moment from 'moment';
import 'moment/locale/ro';
import 'moment/locale/vi';
import { logger } from 'src/helpers/logger';
import { useEffect, useState } from 'react';

class Lang {
  defaultLanguage = 'en';
  allowedLanguages = [
    { value: 'en', label: 'English' },
    { value: 'ro', label: 'Romanian' },
    { value: 'vi', label: 'Vietnamese' }
  ];
  data = {};
  location = {};
  subscriptions = [];

  constructor() {
    this.language = this.defaultLanguage;
    moment.locale(this.defaultLanguage);
  }

  subscribe(cb) {
    this.subscriptions.push(cb);
    cb(this.language);
  }

  unsubscribe(cb) {
    let index = this.subscriptions.indexOf(cb);
    if (index !== -1) {
      this.subscriptions.splice(index, 1);
    }
  }

  t(text, params = {}, deepKey = null) {
    if (!text) return text;
    text = text.toString();
    let data = this.data[this.language] || {};
    if (deepKey) {
      data = data[deepKey];
    }
    if (text === 'Default') text += ' ';
    if (!data[text.toLowerCase()] && this.language !== this.defaultLanguage) {
      logger.debug(`Text [${text}] wasn't translated in ${this.language}.`);
    }

    return (data[text.toLowerCase()] || text)
      .toString()
      .replace(/\{:([^}]+)}/g, (m, g1) => (g1 in params ? params[g1] : m));
  }

  setLocation(location) {
    this.location = location;
  }

  async setLanguage(language) {
    let shortLang = (language || this.defaultLanguage).slice(0, 2);
    if (!this.allowedLanguages.find((l) => l.value === shortLang)) {
      logger.warn('Language is not integrated.');
      shortLang = this.defaultLanguage;
    }

    moment.locale(shortLang);

    if (shortLang === this.language) return;

    if (shortLang !== 'en' && !this.data[shortLang]) {
      const main = await import(`./${shortLang}.json`);
      const tooltip = await import(`./tooltip/${shortLang}.json`);
      const error = await import(`./error/${shortLang}.json`);
      const result = { ...main, ...tooltip, ...error };
      if (!result) {
        return;
      }
      let data = {};
      for (let k in result) {
        data[k.toLowerCase()] = result[k];
      }
      this.data[shortLang] = data;
    }
    this.language = shortLang;
    this.subscriptions.map((cb) => {
      cb(this.language);
    });
  }
}

const lang = new Lang();

function useLanguage() {
  const [value, setLang] = useState(lang.language);

  useEffect(() => {
    lang.subscribe(setLang);
    return () => lang.unsubscribe(setLang);
  }, []);

  return value || '';
}

export { lang, useLanguage };
